/**
 * Constants
 */

exports.levelType = [
  { key: "pre", text: "Preschool", value: "PRESCHOOL" },
  { key: "elem", text: "Elementary", value: "ELEM" },
  { key: "elemp", text: "Elementary - Primary", value: "ELEMP" },
  { key: "elemi", text: "Elementary - Intermediate", value: "ELEMI" },
  { key: "hs", text: "High School", value: "HS" },
  { key: "jrhs", text: "Junior High School", value: "JHS" },
  { key: "srhshumss", text: "Senior High School - HUMSS", value: "SHSHUMSS" },
  { key: "srhsstem", text: "Senior High School - STEM", value: "SHSSTEM" },
  { key: "srhsabm", text: "Senior High School - ABM", value: "SHSABM" },
  // Strengthened SHS (DM 012, s. 2026) replaces strands with two tracks. These
  // values deliberately do not match the SHS<STRAND> checks scattered through
  // the card and the backend summaries, so Grade 11 falls through to the
  // whole-year path instead of the old two-semester one.
  { key: "srhsacad", text: "Senior High School - Academic", value: "SHSACAD" },
  { key: "srhstechpro", text: "Senior High School - TechPro", value: "SHSTECHPRO" },
  { key: "na", text: "N/A", value: "NA" },
];

exports.gradeLevel = [
  { key: "n", text: "Nursery", value: "Nursery" },
  { key: "pk", text: "Pre-Kinder", value: "Pre-Kinder" },
  { key: "k", text: "Kinder", value: "Kinder" },
  { key: "1", text: "Grade 1", value: "Grade 1" },
  { key: "2", text: "Grade 2", value: "Grade 2" },
  { key: "3", text: "Grade 3", value: "Grade 3" },
  { key: "4", text: "Grade 4", value: "Grade 4" },
  { key: "5", text: "Grade 5", value: "Grade 5" },
  { key: "6", text: "Grade 6", value: "Grade 6" },
  { key: "7", text: "Grade 7", value: "Grade 7" },
  { key: "8", text: "Grade 8", value: "Grade 8" },
  { key: "9", text: "Grade 9", value: "Grade 9" },
  { key: "10", text: "Grade 10", value: "Grade 10" },
  { key: "11", text: "Grade 11 - HUMMS", value: "Grade 11 - HUMMS" },
  { key: "12", text: "Grade 11 - STEM", value: "Grade 11 - STEM" },
  { key: "13", text: "Grade 11 - ABM", value: "Grade 11 - ABM" },
  // Strengthened SHS Grade 11 carries no strand. The stranded Grade 11 entries
  // above stay for sections created before SY 2026-2027.
  { key: "17", text: "Grade 11", value: "Grade 11" },
  { key: "14", text: "Grade 12 - HUMMS", value: "Grade 12 - HUMMS" },
  { key: "15", text: "Grade 12 - STEM", value: "Grade 12 - STEM" },
  { key: "16", text: "Grade 12 - ABM", value: "Grade 12 - ABM" },
];

exports.breakdownGradeLevel = [
  { key: "n", text: "Nursery", value: "Nursery" },
  { key: "pk", text: "Pre-Kinder", value: "Pre-Kinder" },
  { key: "k", text: "Kinder", value: "Kinder" },
  { key: "1", text: "Grade 1", value: "Grade 1" },
  { key: "2", text: "Grade 2", value: "Grade 2" },
  { key: "3", text: "Grade 3", value: "Grade 3" },
  { key: "4", text: "Grade 4", value: "Grade 4" },
  { key: "5", text: "Grade 5", value: "Grade 5" },
  { key: "6", text: "Grade 6", value: "Grade 6" },
  { key: "7", text: "Grade 7", value: "Grade 7" },
  { key: "8", text: "Grade 8", value: "Grade 8" },
  { key: "9", text: "Grade 9", value: "Grade 9" },
  { key: "10", text: "Grade 10", value: "Grade 10" },
  { key: "11", text: "Grade 11", value: "Grade 11" },
  { key: "12", text: "Grade 12", value: "Grade 12" },
];

exports.quarter = [
  { key: "1", text: "1st Quarter", value: 1 },
  { key: "2", text: "2nd Quarter", value: 2 },
  { key: "3", text: "3rd Quarter", value: 3 },
  { key: "4", text: "4th Quarter", value: 4 },
];

// Quarter configuration constants
exports.quarterConfig = {
  // Month ranges for each quarter (1-12)
  QUARTER_MONTHS: {
    1: { start: 7, end: 9, name: "July - September" },
    2: { start: 10, end: 12, name: "October - December" },
    3: { start: 1, end: 2, name: "January - February" },
    4: { start: 3, end: 6, name: "March - June" },
  },
  
  // Database field mappings
  DB_FIELDS: {
    grades: {
      1: "firstQuarter",
      2: "secondQuarter", 
      3: "thirdQuarter",
      4: "fourthQuarter",
    },
    conducts: {
      1: "firstQuarter",
      2: "secondQuarter",
      3: "thirdQuarter", 
      4: "fourthQuarter",
    },
  },
  
  // Default quarter settings
  DEFAULT_QUARTER: 1,
  TOTAL_QUARTERS: 4,
  
  // School year settings
  SCHOOL_YEAR_START_MONTH: 7, // July
  SCHOOL_YEAR_END_MONTH: 6,   // June
};

exports.paymentSchedule = [
  { key: "1", text: "Full Cash Basis", value: "Full Cash Basis" },
  { key: "2", text: "Semi-Annual", value: "Semi-Annual" },
  { key: "3", text: "Quarterly", value: "Quarterly" },
  { key: "4", text: "Monthly Basis", value: "Monthly Basis" },
  { key: "5", text: "Others", value: "Others" },
];

exports.subjectCategory = [
  { key: "1", text: "Mother Tongue", value: "Mother Tongue" },
  { key: "2", text: "English", value: "English" },
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  {
    key: "7",
    text: "Technology & Livelihood Education (TLE)",
    value: "Technology & Livelihood Education (TLE)",
  },
  { key: "8", text: "Music", value: "Music" },
  { key: "9", text: "Arts", value: "Arts" },
  { key: "10", text: "Physical Education", value: "Physical Education" },
  { key: "11", text: "Health", value: "Health" },
  { key: "12", text: "Computer Education", value: "Computer Education" },
  {
    key: "13",
    text: "Edukasyon sa Pagpapakatao (ESP)",
    value: "Edukasyon sa Pagpapakatao (ESP)",
  },
  {
    key: "14",
    text: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
    value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
  },
  { key: "15", text: "Values Education", value: "Values" },
  { key: "16", text: "Elective", value: "Elective" },
  { key: "17", text: "Extra-Curricular", value: "Extra-Curricular" },
  { key: "18", text: "Oral Communication", value: "OC" },
  { key: "19", text: "Reading and Writing Skills", value: "RWS" },
  {
    key: "20",
    text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
    value: "KOM",
  },
  {
    key: "21",
    text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
    value: "PAGBASA",
  },
  {
    key: "22",
    text: "21st Century Literature from the Philippines and the World",
    value: "21LIT",
  },
  {
    key: "23",
    text: "Contemporary Philippine Arts from the Regions",
    value: "CPAR",
  },
  { key: "24", text: "Media and Information Literacy", value: "MIL" },
  { key: "25", text: "General Mathematics", value: "GM" },
  { key: "26", text: "Statistics and Probability", value: "SP" },
  { key: "27", text: "Earth and Life Science", value: "ELS" },
  { key: "28", text: "Physical Science", value: "PS" },
  {
    key: "29",
    text: "Introduction to the Philosophy of the Human Person",
    value: "IPHS",
  },
  { key: "30", text: "Physical Education and Health", value: "PEH" },
  { key: "31", text: "Personal Development", value: "PERDEV" },
  {
    key: "32",
    text: "Understanding Culture, Society and Politics",
    value: "UCSP",
  },
  { key: "33", text: "Earth Science", value: "ES" },
  { key: "34", text: "Disaster Readiness and Risk Reduction", value: "DRRR" },
  { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
  { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
  { key: "37", text: "Practical Research 1", value: "PR1" },
  { key: "38", text: "Practical Research 2", value: "PR2" },
  {
    key: "39",
    text: "English for Academic and Professional Purposes",
    value: "EAPP",
  },
  { key: "40", text: "Entrepreneurship", value: "ENTREP" },
  { key: "41", text: "Inquiries, Investigations and Immersions", value: "III" },
  { key: "42", text: "Pre-Calculus", value: "PRECAL" },
  { key: "43", text: "Basic Calculus", value: "BCAL" },
  { key: "44", text: "General Biology 1", value: "BIO1" },
  { key: "45", text: "General Biology 2", value: "BIO2" },
  { key: "46", text: "General Chemistry 1", value: "CHEM1" },
  { key: "47", text: "General Chemistry 2", value: "CHEM2" },
  { key: "48", text: "General Physics 1", value: "PHY1" },
  { key: "49", text: "General Physics 2", value: "PHY2" },
  { key: "50", text: "Work Immersion", value: "WI" },
  { key: "51", text: "Creative Writing", value: "CW" },
  {
    key: "52",
    text: "Introduction to World Religions and Belief Systems",
    value: "IWRBS",
  },
  { key: "53", text: "Creative Non-Fiction", value: "CNF" },
  {
    key: "54",
    text: "Trends, Networks, and Critical Thinking in the 21st Century Culture",
    value: "TRENDS",
  },
  { key: "55", text: "Philippine Politics and Governance", value: "PPG" },
  {
    key: "56",
    text: "Community Engagement, Solidarity, and Citizenship",
    value: "CESC",
  },
  {
    key: "57",
    text: "Disciplines and Ideas in the Social Sciences",
    value: "DISS",
  },
  {
    key: "58",
    text: "Disciplines and Ideas in the Applied Social Sciences",
    value: "DIASS",
  },
  { key: "59", text: "Mother Tongue/ Filipino", value: "MTFilipino" },
  { key: "60", text: "Science/ English", value: "SciEnglish" },
  { key: "61", text: "Capstone Project", value: "CapstoneProject" },
  { key: "62", text: "Culminating Activity", value: "CulminatingActivity" },
  { key: "63", text: "Organization and Management", value: "ORGMGT" },
  { key: "64", text: "Business Math", value: "BUSMATH" },
  {
    key: "65",
    text: "Fundamentals of Accountancy, Business and Management 1",
    value: "FABM1",
  },
  { key: "66", text: "Principles of Marketing", value: "PRINMARKET" },

  //start of updates in subj
  //grade 1
  { key: "67", text: "Good Manners and Right Conduct", value: "GMRC" },
  { key: "68", text: "Language", value: "Language" },
  { key: "69", text: "Makabansa", value: "Makabansa" },
  { key: "70", text: "Reading and Literacy", value: "Reading and Literacy" },
  //end updates for g1

  //grade 11 - Strengthened SHS core (DM 012, s. 2026)
  { key: "83", text: "Effective Communication", value: "Effective Communication" },
  { key: "84", text: "Mabisang Komunikasyon", value: "Mabisang Komunikasyon" },
  { key: "85", text: "Life and Career Skills", value: "Life and Career Skills" },
  { key: "86", text: "General Science", value: "General Science" },
  {
    key: "87",
    text: "Pag-aaral ng Kasaysayan at Lipunang Pilipino",
    value: "Pag-aaral ng Kasaysayan at Lipunang Pilipino",
  },
  //end updates for g11

  // EPP/TLE splits into two components for Grades 4-8. ICT runs the whole
  // term; AFA/FCS/IA changes each term. Weighted 25/75 into the EPP/TLE row.
  { key: "93", text: "ICT", value: "ICT" },
  { key: "94", text: "AFA / FCS / IA", value: "AFA/FCS/IA" },

  //grade 4
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  //end updates for g4
  // ABM 12 Subjects
  {
    key: "73",
    text: "Fundamentals of Accountancy Business and Management 2",
    value: "FABM2",
  },
  { key: "74", text: "Applied Economics", value: "APPECON" },
  { key: "75", text: "Business Finance", value: "BUSFIN" },
  {
    key: "76",
    text: "Business Ethics and Social Responsibility",
    value: "BESR",
  },
  // end if ABM 12 subjects
];

exports.subjectElemP = [
  // { key: '1', text: 'Mother Tongue/ Filipino', value: 'MTFilipino' },
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "5", text: "Science/ English", value: "SciEnglish" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "8", text: "Music", value: "Music" },
  { key: "9", text: "Arts", value: "Arts" },
  { key: "10", text: "Physical Education", value: "Physical Education" },
  { key: "11", text: "Health", value: "Health" },
  {
    key: "13",
    text: "Edukasyon sa Pagpapakatao (ESP)",
    value: "Edukasyon sa Pagpapakatao (ESP)",
  },
];

// Grade 3 under the revised K-10 curriculum, from the registrar's form.
//
// It had been given Grade 1's list - Language and Reading and Literacy - which
// Grade 3 does not teach, so those two rows printed blank while the Filipino
// and English the section actually carries appeared nowhere at all. The school
// splits them by Grade 3; only Grade 1 keeps the combined pair.
exports.subjectGrade3 = [
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "69", text: "Makabansa", value: "Makabansa" },
  { key: "67", text: "GMRC", value: "GMRC" },
];

// Strengthened SHS Grade 11 (DM 012, s. 2026), laid out to match the DepEd
// form the registrar supplied: Core Subjects, then Elective Subjects, each row
// carrying its unit load, ending in a General Average of 39 units.
//
// Row order is the form's, not the old alphabetical-ish one, because the card
// prints the template in order and a registrar checks it against the printed
// form line by line.
//
// Effective Communication and Mabisang Komunikasyon are ONE learning area worth
// 6 units on the form, taught and graded as two subjects. The parent row is the
// average of the two and carries the units; the two print beneath it as
// indented sub-rows, the same shape MAPEH has used for years.
//
// Electives: three rows, one per term, per the form's greyed-out cells. Which
// subject lands in which row comes from SectionSubject.sem - "1", "2" or "3" -
// so the registrar places them rather than the code guessing.
exports.subjectSHS11 = {
  Core: [
    {
      key: "88",
      text: "Effective Communication / Mabisang Komunikasyon",
      value: "Effective Communication / Mabisang Komunikasyon",
      units: 6,
      components: [
        { key: "83", text: "Effective Communication", value: "Effective Communication" },
        { key: "84", text: "Mabisang Komunikasyon", value: "Mabisang Komunikasyon" },
      ],
    },
    { key: "25", text: "General Mathematics", value: "GM", units: 6 },
    { key: "86", text: "General Science", value: "General Science", units: 6 },
    {
      key: "85",
      text: "Life and Career Skills",
      value: "Life and Career Skills",
      units: 6,
    },
    {
      key: "87",
      text: "Pag-aaral ng Kasaysayan at Lipunang Pilipino",
      value: "Pag-aaral ng Kasaysayan at Lipunang Pilipino",
      units: 6,
    },
  ],
  Electives: [
    { key: "89", text: "Academic Elective 1", value: "Academic Elective 1", units: 3, term: 1 },
    { key: "90", text: "Academic Elective 2", value: "Academic Elective 2", units: 3, term: 2 },
    { key: "91", text: "Academic Elective 3", value: "Academic Elective 3", units: 3, term: 3 },
  ],
};

exports.subjectGrade1 = [
  // { key: '1', text: 'Mother Tongue/ Filipino', value: 'MTFilipino' },
  // { key: '2', text: 'English', value: 'English' },
  // { key: '3', text: 'Science', value: 'Science' },
  // { key: '5', text: 'Science/ English', value: 'SciEnglish' },
  // { key: '6', text: 'Araling Panlipunan', value: 'Araling Panlipunan' },
  // { key: '7', text: 'MAPEH', value: 'MAPEH' },
  // { key: '8', text: 'Music', value: 'Music' },
  // { key: '9', text: 'Arts', value: 'Arts' },
  // { key: '10', text: 'Physical Education', value: 'Physical Education' },
  // { key: '11', text: 'Health', value: 'Health' },
  // { key: '13', text: 'Edukasyon sa Pagpapakatao (ESP)', value: 'Edukasyon sa Pagpapakatao (ESP)' },
  { key: "68", text: "Language", value: "Language" },
  { key: "70", text: "Reading and Literacy", value: "Reading and Literacy" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "69", text: "Makabansa", value: "Makabansa" },
  { key: "67", text: "GMRC", value: "GMRC" },
];

exports.subjectGrade2 = [
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  // { key: '3', text: 'Science', value: 'Science' },
  // { key: '5', text: 'Science/ English', value: 'SciEnglish' },
  // { key: '6', text: 'Araling Panlipunan', value: 'Araling Panlipunan' },
  // { key: '7', text: 'MAPEH', value: 'MAPEH' },
  // { key: '8', text: 'Music', value: 'Music' },
  // { key: '9', text: 'Arts', value: 'Arts' },
  // { key: '10', text: 'Physical Education', value: 'Physical Education' },
  // { key: '11', text: 'Health', value: 'Health' },
  // { key: '13', text: 'Edukasyon sa Pagpapakatao (ESP)', value: 'Edukasyon sa Pagpapakatao (ESP)' },
  // { key: "68", text: "Language", value: "Language" },
  // { key: "70", text: "Reading and Literacy", value: "Reading and Literacy" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "69", text: "Makabansa", value: "Makabansa" },
  { key: "67", text: "GMRC", value: "GMRC" },
];

exports.subjectElemI = [
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  { key: "12", text: "Values Education", value: "Values" },
    {
      key: "15",
      text: "EPP / TLE",
      value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
      components: [
        { key: "93", text: "ICT", value: "ICT", weight: 0.25 },
        { key: "94", text: "AFA / FCS / IA", value: "AFA/FCS/IA", weight: 0.75 },
      ],
    },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "8", text: "Music", value: "Music" },
  { key: "9", text: "Arts", value: "Arts" },
  { key: "10", text: "Physical Education", value: "Physical Education" },
  { key: "11", text: "Health", value: "Health" },
];

exports.subjectGrade4 = [
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  { key: "12", text: "Values Education", value: "Values" },
    {
      key: "15",
      text: "EPP / TLE",
      value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
      components: [
        { key: "93", text: "ICT", value: "ICT", weight: 0.25 },
        { key: "94", text: "AFA / FCS / IA", value: "AFA/FCS/IA", weight: 0.75 },
      ],
    },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  { key: "72", text: "PE and Health", value: "PEH" },
];

exports.subjectGrade5 = [
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  { key: "12", text: "Values Education", value: "Values" },
    {
      key: "15",
      text: "EPP / TLE",
      value: "Edukasyong Pantahanan at Pangkabuhayan (EPP)",
      components: [
        { key: "93", text: "ICT", value: "ICT", weight: 0.25 },
        { key: "94", text: "AFA / FCS / IA", value: "AFA/FCS/IA", weight: 0.75 },
      ],
    },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  { key: "72", text: "PE and Health", value: "PEH" },
];

exports.subjectJHS = [
  { key: "3", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "5", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  {
    key: "7",
    text: "Technology & Livelihood Education (TLE)",
    value: "Technology & Livelihood Education (TLE)",
  },
  { key: "8", text: "MAPEH", value: "MAPEH" },
  { key: "9", text: "Music", value: "Music" },
  { key: "10", text: "Arts", value: "Arts" },
  { key: "11", text: "Physical Education", value: "Physical Education" },
  { key: "12", text: "Health", value: "Health" },
  { key: "12", text: "Values Education", value: "Values" },
];

exports.subjectGrade7and8 = [
  { key: "1", text: "Filipino", value: "Filipino" },
  { key: "2", text: "English", value: "English" },
  { key: "4", text: "Mathematics", value: "Mathematics" },
  { key: "3", text: "Science", value: "Science" },
  { key: "6", text: "Araling Panlipunan (AP)", value: "Araling Panlipunan" },
  { key: "12", text: "Values Education", value: "Values" },
    {
      key: "15",
      text: "EPP / TLE",
      value: "Technology & Livelihood Education (TLE)",
      components: [
        { key: "93", text: "ICT", value: "ICT", weight: 0.25 },
        { key: "94", text: "AFA / FCS / IA", value: "AFA/FCS/IA", weight: 0.75 },
      ],
    },
  { key: "7", text: "MAPEH", value: "MAPEH" },
  { key: "71", text: "Music and Arts", value: "Music and Arts" },
  { key: "72", text: "PE and Health", value: "PEH" },
];

exports.subjectHUMSSSHS12 = {
  Core1: [
    {
      key: "29",
      text: "Introduction to the Philosophy of the Human Person",
      value: "IPHS",
    },
    {
      key: "23",
      text: "Contemporary Philippine Arts from the Regions",
      value: "CPAR",
    },
    {
      key: "32",
      text: "Understanding Culture, Society and Politics",
      value: "UCSP",
    },
    { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "38", text: "Practical Research 2", value: "PR2" },
    {
      key: "39",
      text: "English for Academic and Professional Purposes",
      value: "EAPP",
    },
    {
      key: "56",
      text: "Community Engagement, Solidarity, and Citizenship",
      value: "CESC",
    },
    { key: "51", text: "Creative Writing", value: "CW" },
  ],
  Core2: [
    { key: "24", text: "Media and Information Literacy", value: "MIL" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    {
      key: "41",
      text: "Inquiries, Investigations and Immersions",
      value: "III",
    },
    {
      key: "54",
      text: "Trends, Networks, and Critical Thinking in the 21st Century Culture",
      value: "TRENDS",
    },
    { key: "53", text: "Creative Non-Fiction", value: "CNF" },
    { key: "50", text: "Work Immersion", value: "WI" },
  ],
};

exports.subjectHUMSSSHS11 = {
  Core1: [
    { key: "18", text: "Oral Communication", value: "OC" },
    {
      key: "20",
      text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
      value: "KOM",
    },
    { key: "25", text: "General Mathematics", value: "GM" },
    { key: "27", text: "Earth and Life Science", value: "ELS" },
    {
      key: "22",
      text: "21st Century Literature from the Philippines and the World",
      value: "21LIT",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
    // { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    { key: "55", text: "Philippine Politics and Governance", value: "PPG" },
    {
      key: "57",
      text: "Disciplines and Ideas in the Social Sciences",
      value: "DISS",
    },
  ],
  Core2: [
    { key: "19", text: "Reading and Writing Skills", value: "RWS" },
    {
      key: "21",
      text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
      value: "PAGBASA",
    },
    { key: "26", text: "Statistics and Probability", value: "SP" },
    { key: "28", text: "Physical Science", value: "PS" },
    // { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "37", text: "Practical Research 1", value: "PR1" },
    { key: "40", text: "Entrepreneurship", value: "ENTREP" },
    {
      key: "52",
      text: "Introduction to World Religions and Belief Systems",
      value: "IWRBS",
    },
    {
      key: "58",
      text: "Disciplines and Ideas in the Applied Social Sciences",
      value: "DIASS",
    },
  ],
};

exports.subjectSTEMSHS11 = {
  Core1: [
    { key: "18", text: "Oral Communication", value: "OC" },
    {
      key: "20",
      text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
      value: "KOM",
    },
    { key: "25", text: "General Mathematics", value: "GM" },
    { key: "33", text: "Earth Science", value: "ES" },
    {
      key: "22",
      text: "21st Century Literature from the Philippines and the World",
      value: "21LIT",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
    // { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    { key: "42", text: "Pre-Calculus", value: "PRECAL" },
    { key: "44", text: "General Biology 1", value: "BIO1" },
  ],
  Core2: [
    { key: "19", text: "Reading and Writing Skills", value: "RWS" },
    {
      key: "21",
      text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
      value: "PAGBASA",
    },
    { key: "26", text: "Statistics and Probability", value: "SP" },
    { key: "34", text: "Disaster Readiness and Risk Reduction", value: "DRRR" },
    // { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "37", text: "Practical Research 1", value: "PR1" },
    { key: "40", text: "Entrepreneurship", value: "ENTREP" },
    { key: "43", text: "Basic Calculus", value: "BCAL" },
    { key: "45", text: "General Biology 2", value: "BIO2" },
  ],
};

exports.subjectSTEMSHS12 = {
  Core1: [
    {
      key: "29",
      text: "Introduction to the Philosophy of the Human Person",
      value: "IPHS",
    },
    {
      key: "23",
      text: "Contemporary Philippine Arts from the Regions",
      value: "CPAR",
    },
    {
      key: "32",
      text: "Understanding Culture, Society and Politics",
      value: "UCSP",
    },
    { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "38", text: "Practical Research 2", value: "PR2" },
    {
      key: "39",
      text: "English for Academic and Professional Purposes",
      value: "EAPP",
    },
    { key: "48", text: "General Physics 1", value: "PHY1" },
    { key: "46", text: "General Chemistry 1", value: "CHEM1" },
  ],
  Core2: [
    { key: "24", text: "Media and Information Literacy", value: "MIL" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    {
      key: "41",
      text: "Inquiries, Investigations and Immersions",
      value: "III",
    },
    { key: "49", text: "General Physics 2", value: "PHY2" },
    { key: "47", text: "General Chemistry 2", value: "CHEM2" },
    { key: "50", text: "Work Immersion", value: "WI" },
  ],
};

exports.subjectABMSHS11 = {
  Core1: [
    { key: "18", text: "Oral Communication", value: "OC" },
    {
      key: "20",
      text: "Komunikasyon at Pananaliksik sa Wika at Kulturang Pilipino",
      value: "KOM",
    },
    { key: "25", text: "General Mathematics", value: "GM" },
    { key: "27", text: "Earth and Life Science", value: "ELS" },
    {
      key: "22",
      text: "21st Century Literature from the Philippines and the World",
      value: "21LIT",
    },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "35", text: "Empowerment Technologies", value: "EMPTECH" },
    //  { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    { key: "63", text: "Organization and Management", value: "ORGMGT" },
    { key: "64", text: "Business Math", value: "BUSMATH" },
  ],
  Core2: [
    { key: "19", text: "Reading and Writing Skills", value: "RWS" },
    {
      key: "21",
      text: "Pagbasa at Pagsusuri ng Iba't Ibang Teksto Tungo sa Pananaliksik",
      value: "PAGBASA",
    },
    { key: "26", text: "Statistics and Probability", value: "SP" },
    { key: "28", text: "Physical Science", value: "PS" },
    // { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "37", text: "Practical Research 1", value: "PR1" },
    { key: "40", text: "Entrepreneurship", value: "ENTREP" },
    {
      key: "65",
      text: "Fundamentals of Accountancy, Business and Management 1",
      value: "FABM1",
    },
    { key: "66", text: "Principles of Marketing", value: "PRINMARKET" },
  ],
};

exports.subjectABMSHS12 = {
  Core1: [
    {
      key: "29",
      text: "Introduction to the Philosophy of the Human Person",
      value: "IPHS",
    },
    {
      key: "23",
      text: "Contemporary Philippine Arts from the Regions",
      value: "CPAR",
    },
    {
      key: "32",
      text: "Understanding Culture, Society and Politics",
      value: "UCSP",
    },
    { key: "31", text: "Personal Development", value: "PERDEV" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects1: [
    { key: "38", text: "Practical Research 2", value: "PR2" },
    {
      key: "39",
      text: "English for Academic and Professional Purposes",
      value: "EAPP",
    },
    {
      key: "73",
      text: "Fundamentals of Accountancy Business and Management 2",
      value: "FABM2",
    },
    { key: "74", text: "Applied Economics", value: "APPECON" },
  ],
  Core2: [
    { key: "24", text: "Media and Information Literacy", value: "MIL" },
    { key: "30", text: "Physical Education and Health", value: "PEH" },
  ],
  AppliedAndSpecializedSubjects2: [
    { key: "36", text: "Filipino sa Piling Larangan", value: "FPL" },
    {
      key: "41",
      text: "Inquiries, Investigations and Immersions",
      value: "III",
    },
    { key: "75", text: "Business Finance", value: "BUSFIN" },
    {
      key: "76",
      text: "Business Ethics and Social Responsibility",
      value: "BESR",
    },
    { key: "50", text: "Work Immersion", value: "WI" },
  ],
};

exports.paymentTypes = [
  { key: "ue", text: "Upon Enrollment", value: "Upon Enrollment" },
  { key: "res", text: "Reservation", value: "Reservation" },
  { key: "eb", text: "Enrollment Balance", value: "Enrollment Balance" },
  { key: "cob", text: "Carry Over Balance", value: "Carry Over Balance" },
  { key: "others", text: "Others", value: "Others" },
];

exports.breakdownOfFees = [
  {
    gradeLevel: "Nursery",
    tuition: "32,095",
    misc: "4,860",
    books: "4,000",
    total: "40,955",
    subsidy: "",
    grandTotal: "40,955",
  },
  {
    gradeLevel: "Pre-Kinder",
    tuition: "33,791",
    misc: "4,860",
    books: "4,000",
    total: "42,651",
    subsidy: "",
    grandTotal: "42,651",
  },
  {
    gradeLevel: "Kinder",
    tuition: "33,791",
    misc: "8,260",
    books: "4,000",
    total: "46,051",
    subsidy: "",
    grandTotal: "46,051",
  },
  {
    gradeLevel: "Grade 1",
    tuition: "38,464",
    misc: "10,477",
    books: "5,500",
    total: "54,441",
    subsidy: "",
    grandTotal: "54,441",
  },
  {
    gradeLevel: "Grade 2",
    tuition: "38,464",
    misc: "10,477",
    books: "5,500",
    total: "54,441",
    subsidy: "",
    grandTotal: "54,441",
  },
  {
    gradeLevel: "Grade 3",
    tuition: "39,337",
    misc: "12,026",
    books: "6,000",
    total: "57,363",
    subsidy: "",
    grandTotal: "57,363",
  },
  {
    gradeLevel: "Grade 4",
    tuition: "40,242",
    misc: "15,585",
    books: "6,000",
    total: "61,827",
    subsidy: "",
    grandTotal: "61,827",
  },
  {
    gradeLevel: "Grade 5",
    tuition: "40,708",
    misc: "15,634",
    books: "6,000",
    total: "62,342",
    subsidy: "",
    grandTotal: "62,342",
  },
  {
    gradeLevel: "Grade 6",
    tuition: "40,708",
    misc: "18,634",
    books: "6,000",
    total: "65,342",
    subsidy: "",
    grandTotal: "65,342",
  },
  {
    gradeLevel: "Grade 7",
    tuition: "44,780",
    misc: "15,976",
    books: "6,000",
    total: "66,756",
    subsidy: "9,000",
    grandTotal: "57,756",
  },
  {
    gradeLevel: "Grade 8",
    tuition: "44,780",
    misc: "15,976",
    books: "6,000",
    total: "66,756",
    subsidy: "9,000",
    grandTotal: "57,756",
  },
  {
    gradeLevel: "Grade 9",
    tuition: "46,817",
    misc: "16,383",
    books: "6,000",
    total: "69,200",
    subsidy: "9,000",
    grandTotal: "60,200",
  },
  {
    gradeLevel: "Grade 10",
    tuition: "46,817",
    misc: "20,348",
    books: "6,000",
    total: "73,165",
    subsidy: "9,000",
    grandTotal: "64,165",
  },
  {
    gradeLevel: "Grade 11",
    tuition: "14,000",
    misc: "18,000",
    books: "",
    total: "32,000",
    subsidy: "14,000",
    grandTotal: "18,000",
  },
  {
    gradeLevel: "Grade 12",
    tuition: "14,000",
    misc: "24,500",
    books: "",
    total: "38,500",
    subsidy: "14,000",
    grandTotal: "24,500",
  },
];

exports.tuitionFeeSched = [
  {
    id: 1,
    gradeLevel: "Nursery",
    cash: "40,955",
    uponEnrollmentSemi: "22,628",
    semi: "18,628",
    uponEnrollmentQuarterly: "13,364",
    quarterly: "9,364",
    monthly: "3,096",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 4,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 2,
    gradeLevel: "Pre-Kinder",
    cash: "42,651",
    uponEnrollmentSemi: "23,475",
    semi: "19,475",
    uponEnrollmentQuarterly: "13,788",
    quarterly: "9,788",
    monthly: "3,265",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 4,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 3,
    gradeLevel: "Kinder",
    cash: "46,051",
    uponEnrollmentSemi: "25,175",
    semi: "21,175",
    uponEnrollmentQuarterly: "14,638",
    quarterly: "10,638",
    monthly: "3,605",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 4,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 4,
    gradeLevel: "Grade 1",
    cash: "54,442",
    uponEnrollmentSemi: "30,121",
    semi: "24,621",
    uponEnrollmentQuarterly: "17,860",
    quarterly: "12,360",
    monthly: "4,294",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,500",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 5,
    gradeLevel: "Grade 2",
    cash: "54,442",
    uponEnrollmentSemi: "30,121",
    semi: "24,621",
    uponEnrollmentQuarterly: "17,860",
    quarterly: "12,360",
    monthly: "4,294",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 5,500",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 6,
    gradeLevel: "Grade 3",
    cash: "57,363",
    uponEnrollmentSemi: "31,832",
    semi: "25,832",
    uponEnrollmentQuarterly: "18,966",
    quarterly: "12,966",
    monthly: "4,537",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 6,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 7,
    gradeLevel: "Grade 4",
    cash: "61,827",
    uponEnrollmentSemi: "34,064",
    semi: "28,064",
    uponEnrollmentQuarterly: "20,082",
    quarterly: "14,082",
    monthly: "4,983",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 6,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 8,
    gradeLevel: "Grade 5",
    cash: "62,342",
    uponEnrollmentSemi: "34,321",
    semi: "28,321",
    uponEnrollmentQuarterly: "20,211",
    quarterly: "14,211",
    monthly: "5,034",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 6,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 9,
    gradeLevel: "Grade 6",
    cash: "65,342",
    uponEnrollmentSemi: "35,821",
    semi: "29,821",
    uponEnrollmentQuarterly: "20,961",
    quarterly: "14,961",
    monthly: "5,334",
    uponEnrollmentMonthlyPlusBooks: "7,000 + 6,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 10,
    gradeLevel: "Grade 7",
    cash: "66,756",
    uponEnrollmentSemi: "36,528",
    semi: "30,528",
    uponEnrollmentQuarterly: "21,312",
    quarterly: "15,312",
    monthly: "5,276",
    uponEnrollmentMonthlyPlusBooks: "9,000 + 6,000",
    uponEnrollmentMonthly: "9,000",
    withSHSVoucher: false,
  },
  {
    id: 11,
    gradeLevel: "Grade 8",
    cash: "66,756",
    uponEnrollmentSemi: "36,528",
    semi: "30,528",
    uponEnrollmentQuarterly: "21,312",
    quarterly: "15,312",
    monthly: "5,276",
    uponEnrollmentMonthlyPlusBooks: "9,000 + 6,000",
    uponEnrollmentMonthly: "9,000",
    withSHSVoucher: false,
  },
  {
    id: 12,
    gradeLevel: "Grade 9",
    cash: "69,200",
    uponEnrollmentSemi: "37,750",
    semi: "31,750",
    uponEnrollmentQuarterly: "21,925",
    quarterly: "15,925",
    monthly: "5,520",
    uponEnrollmentMonthlyPlusBooks: "9,000 + 6,000",
    uponEnrollmentMonthly: "9,000",
    withSHSVoucher: false,
  },
  {
    id: 13,
    gradeLevel: "Grade 10",
    cash: "73,165",
    uponEnrollmentSemi: "39,732",
    semi: "33,732",
    uponEnrollmentQuarterly: "22,916",
    quarterly: "16,916",
    monthly: "5,917",
    uponEnrollmentMonthlyPlusBooks: "9,000 + 6,000",
    uponEnrollmentMonthly: "9,000",
    withSHSVoucher: false,
  },
  {
    id: 16,
    gradeLevel: "Grade 11",
    cash: "32,000",
    uponEnrollmentSemi: "16,150",
    semi: "16,150",
    uponEnrollmentQuarterly: "8,125",
    quarterly: "8,125",
    monthly: "2,600",
    uponEnrollmentMonthlyPlusBooks: "7,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
  {
    id: 17,
    gradeLevel: "Grade 12",
    cash: "38,500",
    uponEnrollmentSemi: "19,400",
    semi: "19,400",
    uponEnrollmentQuarterly: "16,916",
    quarterly: "16,916",
    monthly: "5,917",
    uponEnrollmentMonthlyPlusBooks: "7,000",
    uponEnrollmentMonthly: "7,000",
    withSHSVoucher: false,
  },
];
